import { TRPCClientError } from '@trpc/client'

// Queries only: a retried mutation could double-book or double-claim, so this is applied to the query defaults alone.
export const MAX_QUERY_RETRIES = 3

// Domain errors are 4xx by construction (ERROR_CODE_TO_TRPC), so retrying one only delays the answer the user must see.
// Shared with the route error boundary, so the two definitions of "transient" cannot drift apart.
export function isRetryableError(error: unknown): boolean {
  if (error instanceof TRPCClientError) {
    const status = (error.data as { httpStatus?: number } | null | undefined)?.httpStatus
    // No httpStatus → the fetch never got a response (network drop, DNS, CORS, aborted). Retry.
    if (status == null) return true
    // A response came back: retry only transient server-side statuses, never a domain 4xx.
    return status >= 500 || status === 408 || status === 429
  }
  // A non-tRPC error escaping the transport is unexpected/transient — give it the same bounded retries.
  return true
}

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_QUERY_RETRIES) return false
  return isRetryableError(error)
}
